import { render } from "./NavCabecera.vue?vue&type=template&id=01930cca"
import script from "./NavCabecera.vue?vue&type=script&lang=js"
export * from "./NavCabecera.vue?vue&type=script&lang=js"

import "./NavCabecera.vue?vue&type=style&index=0&id=01930cca&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__